import * as library  from "base-64";

export const decodeData = (hash, method = "base64") => {
    return library.decode(hash);
}

export const encodeData = (data, method = "base64") => {
    return library.encode(data);
}  